import { gql } from "apollo-boost"

export const getSchedulingPlace = gql`
  query Query($lnt: Float!, $lat: Float!, $placeUrl: String!, $submissionId: String!) {
  getSchedulesPlaces(lnt: $lnt, lat: $lat, placeUrl: $placeUrl, submissionId:$submissionId) {
    lat
    lnt
    submission {
      name
    }
  }
}
`
export const getSameSchedulesPlaces = gql`
  query getSameSchedulesPlaces($submissionId: String!) {
  getSameSchedulesPlaces(submissionId:$submissionId) {
   found
   places
   {
    currentPlaceId
   repeatedPlaceId
   submissionId
   submissionName
   }
  }
}
`

export const getSchedulingPlaceBySubmission = gql`
  query Query($submissionId: ID!) {
  getSchedulesPlacesBySubmission(submissionId: $submissionId) {
    city
    id
    linkplace
    number
    place
    placeUrl
    street
    subdivision
    region
    zipcode
    isBlocking
  }
}
`

export const getSchedulingPlaceBySubmissions = gql`
  query Query($submissionId: ID!) {
  getSchedulesPlacesBySubmission(submissionId: $submissionId) {
    id
    number
    place
    placeUrl
    linkplace
    zipcode
    subdivision
    number
    street
    city
    region
    isBlocking

  }
}
`


export const getSchedulesPlacesBySubmissionActivitys = gql`
  query Query($submissionId: ID!) {
  getSchedulesPlacesBySubmissionActivitys(submissionId: $submissionId) {
    id
    place
    isBlocking
  }
}
`